import { Field } from "@/components/ui/field";

export function LimitsFields(props: {
  repetitions: number;
  onRepetitions: (n: number) => void;
  costLimit: string;
  onCostLimit: (v: string) => void;
  limitError: string | null | undefined;
  maxCost: number;
}) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <Field
        label="Repetitions"
        required
        htmlFor="ne-reps"
        hint="Runs each item this many times, to see how much scores vary."
      >
        <input
          id="ne-reps"
          type="number"
          min={1}
          max={10}
          className="inp w-28 font-mono"
          value={props.repetitions}
          onChange={(e) => props.onRepetitions(Math.max(1, Math.min(10, Number(e.target.value) || 1)))}
        />
      </Field>
      <Field
        label="Cost limit"
        required
        htmlFor="ne-limit"
        error={props.limitError ?? undefined}
        hint={`The run stops once spend passes this. Up to $${props.maxCost.toFixed(2)}.`}
      >
        <div className="flex h-[34px] w-40 items-center gap-1.5 rounded-[7px] border border-input px-2.5">
          <span className="font-mono text-muted">$</span>
          <input
            id="ne-limit"
            inputMode="decimal"
            className="w-full bg-transparent font-mono text-sm outline-0"
            value={props.costLimit}
            onChange={(e) => props.onCostLimit(e.target.value)}
          />
        </div>
      </Field>
    </div>
  );
}
